export const SCREEN_RESIZE = 'SCREEN_RESIZE';
export const UPDATE_USERINPUT_TYPE = 'UPDATE_USERINPUT_TYPE';

const BREAKPOINT_RULES = {
    'blog': (width, height) => (
        width >= 1316
        ? 'desktop'
        : width && width < 1316
        ? 'mobile'
        : null
    ),
    'blog-v2-article': (width, height) => (
        width >= 1024 // based on ux grid system
        ? 'desktop'
        : width && width < 1024
        ? 'mobile'
        : null
    ),
    'blog-v2-list': (width, height) => (
        width >= 1024 // based on ux grid system
        ? 'desktop'
        : width && width < 1024
        ? 'mobile'
        : null
    ),
    'dlp-v2': (width, height) => (
        width >= 801
        ? 'desktop'
        : width && width < 801
        ? 'mobile'
        : null
    ),
    'stellar-grid': (width, height) => (
        width > 1919
        ? 'xlarge'
        : width > 1365
        ? 'large'
        : width > 1023
        ? 'medium'
        : width > 759
        ? 'small'
        : 'xsmall'
    )
}

export const getCustomBreakpoints = (width, height) => (
    Object.keys(BREAKPOINT_RULES)
    .reduce((breakpoints, key) => {
        breakpoints[key] = BREAKPOINT_RULES[key](width, height);
        return breakpoints;
    }, {})
);

export const screenResize = (width, height) => {
    const device = width <= 800 ? 'mobile' : width <= 1024 ? 'tablet' : 'desktop';
    const customBreakpoints = getCustomBreakpoints(width, height);
    
    return {
        type: SCREEN_RESIZE,
        width,
        height,
        device,
        customBreakpoints
    };
};

export const updateUserInputType = (inputType) => {
    return (dispatch, getState) => {
        const store = getState();
        if (inputType !== store.ui.inputType) {
            dispatch({
                type: UPDATE_USERINPUT_TYPE,
                inputType
            });
        }
    };
}
